import { Component, OnInit, ViewChild } from "@angular/core";
import { DuplicateSidebarComponent } from "src/app/v-sidebar/components/duplicates/duplicate.sidebar.component";
import { VSidebarComponent } from "src/app/v-sidebar/v-sidebar.component";
import { Gender, IUser, ContactType, ContactDomain, ICheckInAreaSimple } from '@vierkant-software/types__api';
import { AppService } from "src/services/app.service";
import { IFrontendPaymentOption, IFrontendUser } from "../../contract.interfaces";
import { FormChanged, FormChangedImmed, OnDeactivate, DraftForm, DraftFormType, DraftService, DraftFormChanged } from "src/app/modules/ngx-draft";
import { DateTime } from "luxon";
import { FormArray, FormBuilder } from "@angular/forms";
import { Popover } from "primeng/popover";
import { Globals } from "src/app/services/globals.service";
import { Option } from "src/util/types/global";
import { UserStepperDefinition } from "../../user.stepperdefinition";

interface NameOption extends Option<Gender> {
	patch?: {
		pronouns: string;
		pronouns2: string;
	};
}

export const ContactTypeDefs = {
	[ContactType.Undefined]: { label: '', inputType: 'text' },
	[ContactType.EMail]:     { label: 'E-Mail', inputType: 'email' },
	[ContactType.Phone]:     { label: 'Telefon', inputType: 'tel' },
	[ContactType.Mobile]:    { label: 'Handy', inputType: 'tel' },
	[ContactType.Fax]:       { label: 'Fax', inputType: 'tel' },
};

export const ContactDomainsDefs = {
	[ContactDomain.Undefined]: { label: '' },
	[ContactDomain.Private]:   { label: 'Privat' },
	[ContactDomain.Business]:  { label: 'Geschäftlich' },
};

@Component({
    templateUrl: './person.step.haml',
    styleUrls:   ['./person.step.sass'],
    standalone:  false
})
export class UserPersonStep implements OnInit, FormChanged, FormChangedImmed, OnDeactivate {		// FIXME @Chris IPage needs a cleanup and replacement

    @DraftForm() form: DraftFormType<IFrontendUser>;

	REQUIRED_CONTACT_AMOUNT = UserStepperDefinition.REQUIRED_CONTACT_AMOUNT;

	duplicateSideBarComponent: DuplicateSidebarComponent;

	maxDate = DateTime.now();

	editable: boolean;
	selectedGender?: Option;
	gender = Gender;
	genders: NameOption[] = [
		{label: 'Unbekannt/Kein', 	value: Gender.Undefined,	patch: {pronouns: '', 		pronouns2: ''		}},
		{label: 'Männlich', 		value: Gender.Male, 		patch: {pronouns: 'Er', 	pronouns2: 'Sein'	}},
		{label: 'Weiblich', 		value: Gender.Female, 		patch: {pronouns: 'Sie', 	pronouns2: 'Ihr'	}},
		{label: 'Divers', 			value: Gender.Diverse, 		patch: {pronouns: '', 		pronouns2: ''		}}
	];
	isMaiden: boolean;

	userA?: Partial<IUser>;
	userB?: Partial<IUser>;
	userBImage?: string;

	selectedIndex: number = undefined;
	contactTypes: Option<ContactType>[] = [
		{ value: ContactType.EMail,  	label: 'E-Mail',   icon: "envelope" },
		{ value: ContactType.Phone,  	label: 'Telefon',  icon: "phone" },
		{ value: ContactType.Mobile, 	label: 'Handy',    icon: "mobile" },
		{ value: ContactType.Fax, 	 	label: 'Fax',      icon: "fax" },
	];
	contactDomains: Option<ContactDomain>[] = [
		{ value: ContactDomain.Private,  label: 'Privat',        icon: "house" },
		{ value: ContactDomain.Business, label: 'Geschäftlich',  icon: "suitcase" },
	];

	newContact = this.fb.group({
		type:   [ContactType.Undefined],
		domain: [ContactDomain.Undefined],
	});

	@ViewChild('overlayPanel') overlayPanel: Popover | undefined;

	displayCompare: boolean;

  branchOptions: Option<string>[] = [];

	private initialFormValue: unknown;

	constructor(
		private rightSideBar: VSidebarComponent,
		private appSerive: AppService,
		private draftService: DraftService,
		private fb: FormBuilder,
        public readonly global: Globals
	) { }

	get contacts(): FormArray {
		return <FormArray>this.form.get('contacts');
	}
	get differentContractHolder() {
		return this.form.get('differentContractHolder')?.value;
	}

	ngOnInit() {
		this.duplicateSideBarComponent = undefined;
	}

  public onResolve(data: {branches: ICheckInAreaSimple[]}){
    this.branchOptions = data.branches.map(x => ({label: x.title, value: x.ID}));
    if (this.branchOptions.length === 1 && !this.form.get('branchID')?.value)
      this.form.get('branchID').setValue(this.branchOptions[0]?.value, {emitEvent: false});
    if (this.initialFormValue === undefined)
      this.initialFormValue = this.form.value;
  }

    onDeactivate() {
        this.initialFormValue = this.form.value;
    }

    onFormChangedImmed(values: IUser) {
        if (Object.compare(values, this.initialFormValue))
        this.form.markAsPristine();
    }


	async onFormChanged(data: IUser) { //FIXME @Chris @Jens
		// only search if both the firstname and lastname is set, otherwise search is not meaningful
		if (data.lastname === '' || data.firstname === '' || data.ID) return;   //TODO maidenname

		// TODO only search on userinput

		try {
			const result = await this.appSerive.api.UserWorker.findDuplicates({
				lastname:  data.lastname,
				//alternativeLastname: data.maidenName,
				firstname: data.firstname,
				birthday:  data.birthday,
				gender:    data.gender,
			});
			if (result && result.data.length > 0) {
				if (!this.duplicateSideBarComponent) {
					this.duplicateSideBarComponent = this.rightSideBar.addItem(DuplicateSidebarComponent, { users: result.data, images: result.__files });
				}
				else {
					this.duplicateSideBarComponent.users = result.data;
					this.duplicateSideBarComponent.images = result.__files;
				}

				this.rightSideBar.visible = true;
			}
		} catch(e) {
			console.error('Error: findDuplicates failed', e);
		}
	}

	async createDifferentContractHolder() {
        return await this.draftService.createDraft('users', 'different-contactholder', { chain: true });
    }

	async editDifferentContractHolder(differentContractHolder: Record<string,unknown>) {
		return await this.draftService.createDraft('users', 'different-contactholder', { chain: true, data: differentContractHolder });
	}

	deleteDifferentContractHolder() {
		this.form.get('differentContractHolder').reset();
	}

	async SelectUser(user: Partial<IUser>) {
		console.log('SelectUser called:', user);	// FIXME @Chris do we miss something here?
		/*
			this.service.SetUser(user);
			if (user.addresses.length > 0)
					this.service.SetAddress(user.addresses[0]);
			if (user.ID) {
					const contacts = await this.service.FetchContacts(user.ID);
					this.service.SetContacts(contacts);
			}
			this.person.patchValue({
					firstName: user.firstname,
					familyName: user.lastname,
					gender: this.genders.find(x => x.code === user.gender),
					birthDate: new Date(user.birthday),
			});
			*/
	}

	compareDuplicate(duplicate: Partial<IUser>, image?: string) {
		console.log('compareDuplicate called:', duplicate, this.form.value);
		this.userA = this.form.value as IUser;
		this.userB = duplicate;
		// this.userBImage = image;
		this.displayCompare = true;
	}

	async setFormToDuplicate(event: IUser) {
		this.draftService.recordId = event.ID;
		const tmpUser = await this.appSerive.api.UserWorker.getUser(event.ID, true);
		const PO = await this.appSerive.api.UserWorker.getUserPaymentOptions(event.ID);
		const tmpUserPaymentOptions: IFrontendPaymentOption[] = PO.map(x => ({ ...x.value, isPrimary: x.isPrimary, ID: x.ID }));
		this.form.patchValue(tmpUser.data);
		this.form.patchValue({paymentMethod: tmpUserPaymentOptions}); //FIXME backend doesnt match frontend
		this.form.get('image').patchValue(tmpUser.__files[0]);
	}

	@DraftFormChanged(['gender'])
	genderChanged(ev: { gender: Gender }) {
		this.form.patchValue(this.genders.filter(x => x.value === ev.gender)[0]?.patch);
	}

	addContact() {
		this.contacts.addEntry({});
	}

	triggerValidator() {
		this.form.updateValidators();
	}

	deleteContact(index: number) {
		this.contacts.removeAt(index);
	}

	toggle(event: Event, index?: number) {
		this.selectedIndex = undefined;
		this.overlayPanel?.toggle(event);
		if (index !== undefined)
			this.selectedIndex = index;
	}
}
